const mEditionProductTrackingCodes = {
  mEditionProductTrackingCodes: {
    buttonSecondary: {
      createText: 'Crear Código'
    },

    quote: {
      firstText: 'Aquí puedes crear el código base del pixel de',
      secondText: '(lo que ves cuando creas el píxel), el código de seguimiento de',
      thirdText: 'o de otras plataformas. Estos códigos se insertarán automáticamente en el formulario de venta de tu producto.'
    },

    table: {
      thName: 'Nombre',
      thDelete: 'Eliminar',
      thEdit: 'Editar'
    },

    tooltip: {
      delete: 'Eliminar Código',
      edit: 'Editar Código'
    }
  }
}

export default mEditionProductTrackingCodes
